module.exports = __webpack_public_path__ + "static/img/sharedWelcomeBg.930e459.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharedWelcome/sharedWelcomeBg.jpg
// module id = Cp9K
// module chunks = 1